import React from 'react';

import './Modal.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import { ButtonDanger } from '../../components/Button/Button';

// Trying to make this component reusable


const Modal = (props) => {
    const closeButton = <FontAwesomeIcon icon={faTimes} />;
    const showHideClassName = props.show ? "modal d-block" : "modal d-none";

    return (
        <div className={showHideClassName}>

            <section className={`modal-primary ${props.modalType}`}>
                <div className="close-modal-button-container">

                    <ButtonDanger className="close-modal-button" onClick={props.handleClose} data-testid="modalCloseButton">
                        {closeButton}
                    </ButtonDanger>
                    {/* <button >
                    { closeButton }
                </button> */}

                </div>

                {props.children}
            </section>
        </div>
    )
}


export default Modal

